import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'
import CardCarouselPrototype from './prototype/CardCarousel'
import type { CardCarouselProps } from './prototype/CardCarousel/types'

export const CardCarousel = ({ data }: ComponentProps<PartData>) => {
	const { overline, title, cards = [], prevLabel, nextLabel } = (data || {}) as CardCarouselProps

	return (
		<CardCarouselPrototype
			overline={overline}
			title={title}
			cards={cards}
			prevLabel={prevLabel}
			nextLabel={nextLabel}
		/>
	)
}
